import SystemSearchEmptyResultImage from "../../images/SystemSearchEmptyResultImage";
import {SystemSecondaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";

export default function GlossaryResearchVoid({clearResearch}) {
    // Used in GlossaryContent to display message
    // for empty result research

    // BUILD
    return (
        <div className={"animate-appearSlow w-full grow overflow-auto flex justify-center items-center"}>
            <div className={"mt-[24px] w-[360px] max-w-[360px] flex flex-col justify-center items-center"}>
                <SystemSearchEmptyResultImage />
                <span className={"text-greyLight7 text-center"}>
                    {"Oops, je n'ai trouvé aucun mot qui correspond à ta recherche"}
                </span>
                <SystemSecondaryCustomButton
                    label={"Réinitialiser la recherche"}
                    isDisabled={false}
                    isLoading={false}
                    isFullWidth={false}
                    sizeStyle={kButtonStyles.smallButtonStyle}
                    onButtonClick={clearResearch}
                    extraClass={"mt-[16px]"}/>
            </div>
        </div>
    );
}